import classNames from 'classnames'

import { valueStringCheck } from '@apps-common/helpers/value-string-check'

interface IProps {
  value?: string
  textValue: string
  className?: string
}

export const ValueWithText: React.FC<IProps> = (props) => {
  const { value, textValue, className } = props

  return (
    <p className={classNames('jost text-[0.75rem] text-ellipsis whitespace-nowrap overflow-hidden text-text', className)}>
      <span className='bg-surface-2 text-text border border-border rounded-md px-[4px]'>{textValue}</span>
      <span className='px-[4px]'>{valueStringCheck(value)}</span>
    </p>
  )
}
